// @flow
import { createAction } from 'redux-actions';
import type { Action, Path, Confirmation } from 'esm-web-pro/redux/confirmations/reducer';
import { ASK_FOR_CONFIRMATION, CLOSE, PROCEED } from './constants';


// eslint-disable-next-line import/prefer-default-export
export const askForConfirmation = createAction(
    ASK_FOR_CONFIRMATION, (
        category: string, type: string, data: Action | Path, confirmation?: Confirmation,
    ) => ({ category, data: { type, data, confirmation } }),
);

export const closeConfirmation = createAction(CLOSE);

export const proceed = createAction(
    PROCEED, (category, action) => ({ category, action }),
);
